<template>
	<div id="app">
		<Header></Header>    
		<div>
			<router-view></router-view>	
		</div>
    <Footer></Footer>
	</div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'


export default {
	name: 'App',
  // metaInfo: {
  //   title: '内向型の人たちを多大なる成功と栄光へ',
  //   titleTemplate: '%s | 超詳細内向型診断「イントロバーツ」'
  // },
	components: {
		Header,
		Footer,    
	},

}
</script>

<style lang="scss">


@import "./scss/_variables.scss";

#app{
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-overflow-scrolling: touch;
	scroll-behavior: smooth;
	//will-change: transform;
	text-align: center;
	color: #2c3e50;
	overflow: hidden; /* 要素にはみ出すアニメーションでのスクロール回避 */
}
body,
html{
	margin:0;
	padding:0;
  height: auto
}




/*===================================================================
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □

〇 Typekit service 〇

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □      
====================================================================*/

/*
 * The Typekit service used to deliver this font or fonts for use on websites
 * is provided by Adobe and is subject to these Terms of Use
 * http://www.adobe.com/products/eulas/tou_typekit. For font license
 * information, see the list below.
 *
 * futura-pt-bold:
 *   - http://typekit.com/eulas/00000000000000003b9af1e4
 * objektiv-mk2:
 *   - http://typekit.com/eulas/00000000000000007735b581
 *   - http://typekit.com/eulas/00000000000000007735b585
 *
 * © 2009-2021 Adobe Systems Incorporated. All Rights Reserved.
 */
/*{"last_published":"2021-05-10 08:31:30 UTC"}*/

@import url("https://p.typekit.net/p.css?s=1&k=jwa3vkz&ht=tk&f=26983.26985.32874&a=4628890&app=typekit&e=css");

@font-face {
font-family:"objektiv-mk2";
src:url("https://use.typekit.net/af/069915/00000000000000007735b581/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/069915/00000000000000007735b581/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/069915/00000000000000007735b581/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;
}

@font-face {
font-family:"objektiv-mk2";
src:url("https://use.typekit.net/af/b5af0a/00000000000000007735b585/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3") format("woff2"),url("https://use.typekit.net/af/b5af0a/00000000000000007735b585/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3") format("woff"),url("https://use.typekit.net/af/b5af0a/00000000000000007735b585/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:800;
}

@font-face {
font-family:"futura-pt-bold";
src:url("https://use.typekit.net/af/053fc9/00000000000000003b9af1e4/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/053fc9/00000000000000003b9af1e4/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/053fc9/00000000000000003b9af1e4/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;
}

.tk-objektiv-mk2 { font-family: "objektiv-mk2",sans-serif; }
.tk-futura-pt-bold { font-family: "futura-pt-bold",sans-serif; }

/*===================================================================
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □

〇 スタイルのリセット 〇

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □      
====================================================================*/
/* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Remove default padding */
ul[class],
ol[class] {
  padding: 0;
}

/* Remove default margin */
body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
figure,
blockquote,
dl,
dd {
  margin: 0;
}

/* Set core body defaults */
body {
  //min-height: 100vh;
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  //line-height: 1.5;
}

/* Remove list styles on ul, ol elements with a class attribute */
ul[class],
ol[class] {
  list-style: none;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Make images easier to work with */
/* img {
  max-width: 100%;
  display: block;
} */


/*===================================================================
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □

〇 フォームのリセット 〇

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □      
====================================================================*/
input,
button,
select,
textarea {  
	border: none;
	font: inherit;
	outline: none;
}

textarea {
	resize: vertical;
}


input[type='submit'],
input[type='button'],
input[type='radio'],
label,
button,
select {
	cursor: pointer;
}




/*============================================
	― PC表示
=============================================*/
.pc-disblock {
  display: block;
}

.pc-disline {
  display: inline;
}

.pc-dislineblock {
  display: inline-block;
}

.pc-none {
  display: none;
}

.sp-disblock {
  display: none;
}
.sp-disline {
  display: none;
}

.sp-dislineblock {
  display: none;
}

/*============================================
	― スマホ表示切り替え
=============================================*/
@media screen and (max-width: 767px) {
  .pc-disblock {
    display: none;
  }

  .pc-disline {
    display: none;
  }

  .pc-dislineblock {
    display: none;
  }

  .sp-disblock {
    display: block;
  }
  .sp-disline {
    display: inline;
  }

  .sp-dislineblock {
    display: inline-block;
  }
  .sp-none {
    display: none;
  }
}

</style>
